import { useToast } from "../../../../hooks/useToast";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Suspense, useMemo, useState } from "react";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import { FormularioBusquedaSII } from "../components/formularioBusquedaSII";
import { FiltroBusquedaSII } from "../models/filtroBusquedaSII";
import { Box, Grid2, Paper } from "@mui/material";
import Tabla from '../../../../components/ui/materialui/serverSideTable';
import { UseColumns } from "../utils/columns";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import DescriptionIcon from '@mui/icons-material/Description';
import UseCertificadoSII from "../hooks/useCertificadoSII";
import { HttpStatusCode } from "axios";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { FiltroGeneracionSIIIndividual, FiltroGeneracionSIIMasivo } from "../models/filtroGeneracionSII";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";

export default function CertificadoSii() {

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Reportes', url: `/reportes` },
        { label: 'Certificados', active: true },
    ]
    const urlTabla = "siscred-api-reportes/v1/certificado-sii/buscar";
    const controlTabla = useDataFetch(urlTabla, new URLSearchParams(), true);

    const { addToast } = useToast();
    const { generarCertificadoIndividual, generarCertificadoMasivo} = UseCertificadoSII();

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => { },
    });

    const [formularioUtilizado, setFormularioUtilizado] = useState<FiltroBusquedaSII>({
        anio: 0,
        numeroCertificado: 0
    })

    const onSubmitSearch = async (e: FiltroBusquedaSII) => {
        if (e.anio){
            controlTabla.manejarCambiosFiltros(
                'filters.anio',
                e.anio.toString(),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                anio: e.anio
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.anio',
                '0',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                anio: 0
            }));
        }

        if (e.numeroCertificado){
            controlTabla.manejarCambiosFiltros(
                'filters.numeroCertificado',
                e.numeroCertificado.toString(),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                numeroCertificado: e.numeroCertificado
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.numeroCertificado',
                '0',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                numeroCertificado: 0
            }));
        }

        if (e.nombre){
            controlTabla.manejarCambiosFiltros(
                'filters.nombre',
                e.nombre.toString(),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                nombre: e.nombre
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.nombre',
                '',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                nombre: ''
            }));
        }

        if (e.rut){
            controlTabla.manejarCambiosFiltros(
                'filters.rut',
                e.rut.toString().replaceAll(".", ""),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                rut: e.rut
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.rut',
                '',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                rut: ''
            }));
        }

        if (e.numeroOperacion){
            controlTabla.manejarCambiosFiltros(
                'filters.numeroOperacion',
                e.numeroOperacion.toString(),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                numeroOperacion: e.numeroOperacion
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.numeroOperacion',
                '',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                numeroOperacion: ''
            }));
        }

        if (e.esGuardado){
            controlTabla.manejarCambiosFiltros(
                'filters.esGuardado',
                e.esGuardado.toString(),
            );

            setFormularioUtilizado((prev) => ({
                ...prev,
                esGuardado: e.esGuardado
            }));
        }
        else{
            controlTabla.manejarCambiosFiltros(
                'filters.esGuardado',
                '',
            );
            setFormularioUtilizado((prev) => ({
                ...prev,
                esGuardado: ''
            }));
        }

        controlTabla.fetchData();     
    }

    const onSubmitCertificadoIndividual = async (mutuoId: number) => {
        const filtroGeneracion : FiltroGeneracionSIIIndividual = {anio: formularioUtilizado.anio, numeroCertificado: formularioUtilizado.numeroCertificado, mutuoId}
        const response = await generarCertificadoIndividual(filtroGeneracion)
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created){
            addToast({
              mostrar: true,
              titulo: 'Confirmación',
              tipo: 'Success',
              mensaje: 'Se envió correctamente la solicitud de certificación para el mutuo seleccionado',
            });
            //PARA PROBAR DESCARGA
            if (response.data && response.data.fileContent && response.data.fileContent != ""){
                const byteCharacters = atob(response.data.fileContent);
                const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.data.fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            onSubmitSearch(formularioUtilizado);
        }
    }

    const onSubmitGeneracionMasiva = () => {
        setModalConfirmacion({
            show: true,
            title: 'Generación masiva de certificados SII',
            message: 'Se generarán certificados para todos los mutuos que cumplan con los filtros indicados ¿Desea continuar?',
            metodo: async () => {
                const filtrosMasivos : FiltroGeneracionSIIMasivo = {
                    anio: formularioUtilizado.anio,
                    numeroCertificado: formularioUtilizado.numeroCertificado,
                    nombre: formularioUtilizado.nombre,
                    rut: formularioUtilizado.rut,
                    numeroOperacion: formularioUtilizado.numeroOperacion,
                    esGuardado: formularioUtilizado.esGuardado != null ? formularioUtilizado.esGuardado === "S" : null
                }
                const response = await generarCertificadoMasivo(filtrosMasivos);
                if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created){
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: 'La solicitud de generación masiva de certificados SII se envió correctamente',
                    });
                }
            }
        });
    }

    const { COLUMNS } = UseColumns({generarCertificadoIndividual: onSubmitCertificadoIndividual});
    const columns = useMemo(() => COLUMNS, [onSubmitCertificadoIndividual]);

    return (
        <Suspense>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                title={modalConfirmacion.title}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
            />
            <Breadcrumb items={breadcrumbItems} />
            <Paper elevation={3} sx={{ p: 3 }}>
                <CustomAccordion
                    title='Filtros'
                    expandedDefault
                >
                    <FormularioBusquedaSII onSubmit={onSubmitSearch}/>
                </CustomAccordion>
                <Box sx={{ mt: 4 }}>
                    <Tabla
                        control={controlTabla}
                        url={urlTabla}
                        callApi={false}
                        columns={columns}
                        titulo={""}
                    />
                </Box>
                <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                    <MButton variant="contained" color="primary" startIcon={<DescriptionIcon />} disabled={controlTabla.data.length === 0}
                    onClick={onSubmitGeneracionMasiva}>
                        Generar certificados
                    </MButton>
                </Grid2>
            </Paper>      
        </Suspense>
    )
}